// extracted by mini-css-extract-plugin
export default {"stickyCategoryHeader":"components-Combobox-components-StickyCategoryHeader-StickyCategoryHeader-module__stickyCategoryHeader--gUn5C"};